/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2025 (original work) Open Assessment Technologies SA ;
 */

/**
 * Add scroll-shadow when there's content to which user can scroll to.
 * @param {Array<node?, Function?>} nodesWithCallbacks - nodes and callbacks:
 *  callback `scrollShadowClasses: String => void` - if not specified, classes will be toggled by this util.
 * @returns {Function} destroy function
 */
export let addScrollShadows = nodesWithCallbacks => {
    if (!nodesWithCallbacks.some(([el]) => el)) {
        return () => {};
    }

    const detectShadows = (el, callback) => {
        let hasRight = el.scrollLeft < -2;
        let hasLeft = el.scrollLeft > 2 + el.clientWidth - el.scrollWidth;
        // let hasBottom = el.scrollTop < el.scrollHeight - el.clientHeight - 2;
        // let hasTop = el.scrollTop > 2;

        if (callback) {
            callback(hasLeft, hasRight, el.scrollLeft);
        }
    };

    const nodeEntries = new Map();
    for (const [el, callback] of nodesWithCallbacks) {
        if (el) {
            nodeEntries.set(el, {
                detectShadows: () => detectShadows(el, callback)
            });
        }
    }

    const resizeObserver = new ResizeObserver(entries => {
        for (const entry of entries) {
            nodeEntries.get(entry.target)?.detectShadows();
        }
    });

    for (const el of nodeEntries.keys()) {
        resizeObserver.observe(el);

        el.addEventListener('scroll', () => {
            nodeEntries.get(el)?.detectShadows();
        });
    }

    //destroy
    return () => {
        resizeObserver.disconnect();
    };
};
